// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"b8e65c5e","348":"26a6e0cd","372":"818f1692","458":"c9b2fbbc","466":"cd827eab","519":"f61a3e4a","738":"3531bd45","774":"5c5dd3d1","787":"0601e4d6","819":"cafe4a8d","856":"31da588b","858":"2be04eaa"}[chunkId] + ".chunk.js";
};